<template>
  <div>
    <h1>Editar Servicio</h1>
    <div>
      <form
        action="#"
        method="post"
        @submit.prevent="editarServicio(servicio, $route.params.id)"
        class="form_presupuesto_nuevo"
      >
        <div class="form_section">
          <label for="nombre">Nombre</label>
          <input
            type="text"
            name="nombre"
            id="nombre"
            v-model="servicio.nombre"
            :disabled="cargando"
          >
          <div
          class="form_mensaje_error"
            v-if="errores.nombre !== null"
          >
            {{ errores.nombre[0] }}
          </div>
        </div>
        <div class="form_section">
          <label for="descripcion">Descripción</label>
          <textarea
            name="descripcion"
            id="descripcion"
            v-model.number="servicio.descripcion"
          ></textarea>
        </div>
         <div class="form_section">
          <label for="categoria_id">Categoría</label>
          <!-- <v-select :options="categorias" label="title"></v-select> -->
          <select
            id="categoria_id"
            name="categoria_id"
            class="form minimal"
            v-model.number="servicio.categoria_id"
            :disabled="cargando"
            @change="onChangeCategoria($event)"
          >
            <option
              v-for="categoria in categorias"
              :value="categoria.categoria_id"
              :key="categoria.categoria_id"
            >
              {{ categoria.nombre }}
            </option>
          </select>
          <div
          class="form_mensaje_error"
            v-if="errores.categoria_id !== null"
          >
            {{ errores.categoria_id[0] }}
          </div>
        </div>
        <div class="form_section" v-if="mostrarYear">
          <label for="year_id">Año</label>
          <select
            id="year_id"
            name="year_id"
            class="form minimal"
            v-model.number="servicio.year_id"
            :disabled="cargando"
          >
            <option
              v-for="concepto in years"
              :value="concepto.year_id"
              :key="concepto.year_id"
            >
              {{ concepto.year }}
            </option>
          </select>
          <div
          class="form_mensaje_error"
            v-if="errores.year_id !== null"
          >
            {{ errores.year_id[0] }}
          </div>
        </div>
        <div class="form_section">
          <label for="moneda_id">Moneda</label>
          <select
            id="moneda_id"
            name="moneda_id"
            class="form minimal"
            v-model.number="servicio.moneda_id"
            :disabled="cargando"
          >
            <option
              v-for="concepto in monedas"
              :value="concepto.moneda_id"
              :key="concepto.moneda_id"
            >
              {{ concepto.nombre }}
            </option>
          </select>
          <div
          class="form_mensaje_error"
            v-if="errores.moneda_id !== null"
          >
            {{ errores.moneda_id[0] }}
          </div>
        </div>
        <!-- <div class="form_section">
          <label for="cuotas">Cantidad de cuotas</label>
          <select
            id="cuotas_cantidad"
            name="cuotas_cantidad"
            class="form minimal"
            v-model.number="servicio.cuotas_cantidad"
            :disabled="cargando"
            @change="onChange($event)"
          >
            <option
              v-for="pago in pagos"
              :value="pago.cuota_numero"
              :key="pago.cuota_numero"
            >
              {{ pago.nombre }}
            </option>
          </select>
          <div
          class="form_mensaje_error"
            v-if="errores.cuotas_cantidad !== null"
          >
            {{ errores.cuotas_cantidad[0] }}
          </div>
        </div> -->
        <div
          v-if="mostrarCuotas"
        >
          <div
            v-for="pago in pagos2"
            :key="`precio_${pago.cuota_numero}`">
            <div class="form_section">
              <h2>Cuota # {{ pago.cuota_numero }}</h2>
              <input
                type="hidden"
                :name="`precio_id_${pago.cuota_numero}`"
                :id="`precio_id_${pago.cuota_numero}`"
                :v-model="servicio.cuotas[ pago.cuota_numero  - 1].cuota_numero"
              >
              <label :for="`precio_${pago.cuota_numero}`">Precio</label>
              <input
                type="text"
                :name="`precio_${pago.cuota_numero}`"
                :id="`precio_${pago.cuota_numero}`"
                v-model="servicio.cuotas[ pago.cuota_numero  - 1].precio"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error"
              v-if="errores['cuotas.' + numeroCuota(pago.cuota_numero) + '.precio'] !== null"
              >
                {{ errorPrecioCuota(pago.cuota_numero) }}
              </div>
            </div>
            <div class="form_section">
              <label :for="`fecha_inicio_${pago.cuota_numero}`">Desde</label>
              <input
                type="date"
                :name="`fecha_inicio_${pago.cuota_numero}`"
                :id="`fecha_inicio_${pago.cuota_numero}`"
                v-bind:class = "(pago.cuota_numero != 1)?'class_no_1':'class_si_1'"
                v-model="servicio.cuotas[ pago.cuota_numero  - 1].fecha_inicio"
                :disabled="pago.cuota_numero != 1"
              >
              <div
              class="form_mensaje_error"
              v-if="errores['cuotas.' + numeroCuota(pago.cuota_numero) + '.fecha_inicio'] !== null"
              >
                {{ errorFechaInicioCuota(pago.cuota_numero) }}
              </div>
            </div>
            <div class="form_section">
              <label :for="`fecha_finalizacion_${pago.cuota_numero}`">Hasta</label>
              <input
                type="date"
                :name="`fecha_finalizacion_${pago.cuota_numero}`"
                :id="`fecha_finalizacion_${pago.cuota_numero}`"
                v-model="servicio.cuotas[ pago.cuota_numero  - 1].fecha_finalizacion"
                :disabled="cargando"
                @change="copiarFechaMasUnDia(pago.cuota_numero)"
              >
              <div
              class="form_mensaje_error"
              v-if="errores['cuotas.' + numeroCuota(pago.cuota_numero) + '.fecha_finalizacion'] !== null"
              >
                {{ errorFechaFinalizacionCuota(pago.cuota_numero) }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="form_mensaje_error"
            v-if="errores.cuotas_general !== null"
          >
            {{ errores.categoria_id[0] }}
          </div> -->
        <button type="button" @click="eliminarCuota(cantinadCuotas)" v-if="this.servicio.cuotas.length != 1">Eliminar Cuota</button>
        <button type="button" @click="agregarCuota(cantinadCuotas)">Agregar Cuota</button>
        <button type="submit" class="boton_guardar">Editar Servicio</button>
      </form>
    </div>
  </div>
</template>

<script>
import serviciosService from '../services/servicios'
import pagosService from '../services/pagos'
import store from './../store'
export default {
  name: 'crearServicio',
  components: {
  },
  data: function () {
    return {
      store,
      mostrarYear: true,
      cantinadCuotas: null,
      categorias: [],
      years: [],
      monedas: [],
      pagos2: [],
      pagos: [{
        cuota_numero: 1,
        nombre: 1
      }, {
        cuota_numero: 2,
        nombre: 2
      }, {
        cuota_numero: 3,
        nombre: 3
      }, {
        cuota_numero: 4,
        nombre: 4
      }, {
        cuota_numero: 5,
        nombre: 5
      }, {
        cuota_numero: 6,
        nombre: 6
      }, {
        cuota_numero: 7,
        nombre: 7
      }, {
        cuota_numero: 8,
        nombre: 8
      }, {
        cuota_numero: 9,
        nombre: 9
      }, {
        cuota_numero: 10,
        nombre: 10
      }, {
        cuota_numero: 11,
        nombre: 11
      }, {
        cuota_numero: 12,
        nombre: 12
      }],
      cargando: false,
      servicio: {
        nombre: null,
        descripcion: null,
        year_id: null,
        categoria_id: null,
        cuotas_cantidad: null
      },
      errores: {
        nombre: null,
        descripcion: null,
        moneda_id: null,
        year_id: null,
        categoria_id: null,
        cuotas_cantidad: null,
        cuotas: null,
        'cuotas.0.precio': null,
        'cuotas.1.precio': null,
        'cuotas.2.precio': null,
        'cuotas.3.precio': null,
        'cuotas.4.precio': null,
        'cuotas.5.precio': null,
        'cuotas.6.precio': null,
        'cuotas.7.precio': null,
        'cuotas.8.precio': null,
        'cuotas.9.precio': null,
        'cuotas.10.precio': null,
        'cuotas.11.precio': null,
        'cuotas.0.fecha_inicio': null,
        'cuotas.1.fecha_inicio': null,
        'cuotas.2.fecha_inicio': null,
        'cuotas.3.fecha_inicio': null,
        'cuotas.4.fecha_inicio': null,
        'cuotas.5.fecha_inicio': null,
        'cuotas.6.fecha_inicio': null,
        'cuotas.7.fecha_inicio': null,
        'cuotas.8.fecha_inicio': null,
        'cuotas.9.fecha_inicio': null,
        'cuotas.10.fecha_inicio': null,
        'cuotas.11.fecha_inicio': null,
        'cuotas.0.fecha_finalizacion': null,
        'cuotas.1.fecha_finalizacion': null,
        'cuotas.2.fecha_finalizacion': null,
        'cuotas.3.fecha_finalizacion': null,
        'cuotas.4.fecha_finalizacion': null,
        'cuotas.5.fecha_finalizacion': null,
        'cuotas.6.fecha_finalizacion': null,
        'cuotas.7.fecha_finalizacion': null,
        'cuotas.8.fecha_finalizacion': null,
        'cuotas.9.fecha_finalizacion': null,
        'cuotas.10.fecha_finalizacion': null,
        'cuotas.11.fecha_finalizacion': null
      }
    }
  },
  methods: {
    eliminarCuota () {
      this.servicio.cuotas.splice(-1)
      this.cantinadCuotas = this.cantinadCuotas - 1
      this.servicio.cuotas_cantidad = this.servicio.cuotas.length
    },
    agregarCuota (id) {
      this.cantinadCuotas = this.cantinadCuotas + 1
      console.log('wwwyrtyt6676')
      this.servicio.cuotas.push({
        cuota_numero: id,
        cuota_id: null,
        precio: null,
        fecha_inicio: this.copiarFechaMasUnDia2(id),
        fecha_finalizacion: null
      })
      this.servicio.cuotas_cantidad = this.servicio.cuotas.length
      console.log(this.servicio.cuotas_cantidad)
    },
    copiarFechaMasUnDia (id) {
      console.log(id)
      console.log(this.servicio)
      console.log(this.servicio.cuotas[id - 1].fecha_finalizacion)
      // var dateString = this.servicio.cuotas[id - 1].fecha_finalizacion
      // var startDate = new Date(dateString)
      // // seconds * minutes * hours * milliseconds = 1 day
      // // var day = 60 * 60 * 24 * 1000;
      // var endDate = new Date(startDate.getDate() + 1)
      // var dateString = 'Mon Jun 30 2014 00:00:00'
      // var startDate = new Date(dateString)
      // var date = this.servicio.cuotas[id - 1].fecha_finalizacion
      // console.log(date)
      // console.log(date.getDate())
      console.log(new Date(new Date().setDate(new Date().getDate() + 1)))
      // console.log(new Date(new Date().setDate(endDate)))
      var date = new Date(this.servicio.cuotas[id - 1].fecha_finalizacion)
      var nextDate = new Date(date.setDate(date.getDate() + 1))
      var formatted = nextDate.getUTCFullYear() + '-' + this.padNumber(nextDate.getUTCMonth() + 1) + '-' + this.padNumber(nextDate.getUTCDate())
      console.log(formatted)
      // this.servicio.cuotas[id].fecha_inicio = this.servicio.cuotas[id - 1].fecha_finalizacion
      console.log(this.servicio.cuotas)
      // return formatted
      this.servicio.cuotas[id].fecha_inicio = formatted
      // document.querySelectorAll('.class_no_1')[id - 1].value = this.servicio.cuotas[id - 1].fecha_finalizacion
      // document.querySelectorAll('.class_no_1')[id - 1].value = formatted
    },
    copiarFechaMasUnDia2 (id) {
      console.log(this.servicio.cuotas[id - 2].fecha_finalizacion)
      console.log(new Date(new Date().setDate(new Date().getDate() + 1)))
      // console.log(new Date(new Date().setDate(endDate)))
      var date = new Date(this.servicio.cuotas[id - 2].fecha_finalizacion)
      var nextDate = new Date(date.setDate(date.getDate() + 1))
      var formatted = nextDate.getUTCFullYear() + '-' + this.padNumber(nextDate.getUTCMonth() + 1) + '-' + this.padNumber(nextDate.getUTCDate())
      console.log(this.servicio.cuotas[id - 2].fecha_finalizacion)
      console.log(formatted)
      if (this.servicio.cuotas[id - 2].fecha_finalizacion != null) {
        return formatted
      }
    },
    padNumber (number) {
      var string = '' + number
      string = string.length < 2 ? '0' + string : string
      return string
    },
    onChangeCategoria (event) {
      console.log('ewewewewe')
      console.log(event.target.value)
      // console.log(event.target.name)
      // console.log(document.getElementsByClassName('year'))
      if (event.target.value === '1' || event.target.value === '2') {
        console.log(event.target.value)
        this.mostrarYear = true
        // document.getElementById('year_editable').style.display = 'flex'
      } else {
        this.mostrarYear = false
        // document.getElementById('year_editable').style.display = 'none'
      }
      // console.log(this.productos[event.target.value - 1].precio)
      // // document.getElementsByName('precio-' + numero)[0].value = this.productos[event.target.value - 1].precio
      // this.servicio.productos[numero - 1].precio = this.productos[event.target.value - 1].precio
    },
    // onChange (id) {
    //   this.errores = {
    //     nombre: null,
    //     precio_no_socio: null,
    //     descripcion: null,
    //     moneda_id: null,
    //     cuotas_cantidad: null,
    //     cuotas: null,
    //     categoria_id: null,
    //     'cuotas.0.precio': null,
    //     'cuotas.1.precio': null,
    //     'cuotas.2.precio': null,
    //     'cuotas.3.precio': null,
    //     'cuotas.4.precio': null,
    //     'cuotas.5.precio': null,
    //     'cuotas.6.precio': null,
    //     'cuotas.7.precio': null,
    //     'cuotas.8.precio': null,
    //     'cuotas.9.precio': null,
    //     'cuotas.10.precio': null,
    //     'cuotas.11.precio': null,
    //     'cuotas.0.fecha_inicio': null,
    //     'cuotas.1.fecha_inicio': null,
    //     'cuotas.2.fecha_inicio': null,
    //     'cuotas.3.fecha_inicio': null,
    //     'cuotas.4.fecha_inicio': null,
    //     'cuotas.5.fecha_inicio': null,
    //     'cuotas.6.fecha_inicio': null,
    //     'cuotas.7.fecha_inicio': null,
    //     'cuotas.8.fecha_inicio': null,
    //     'cuotas.9.fecha_inicio': null,
    //     'cuotas.10.fecha_inicio': null,
    //     'cuotas.11.fecha_inicio': null,
    //     'cuotas.0.fecha_finalizacion': null,
    //     'cuotas.1.fecha_finalizacion': null,
    //     'cuotas.2.fecha_finalizacion': null,
    //     'cuotas.3.fecha_finalizacion': null,
    //     'cuotas.4.fecha_finalizacion': null,
    //     'cuotas.5.fecha_finalizacion': null,
    //     'cuotas.6.fecha_finalizacion': null,
    //     'cuotas.7.fecha_finalizacion': null,
    //     'cuotas.8.fecha_finalizacion': null,
    //     'cuotas.9.fecha_finalizacion': null,
    //     'cuotas.10.fecha_finalizacion': null,
    //     'cuotas.11.fecha_finalizacion': null
    //   }
    //   console.log(id.target.value)
    //   this.pagos2 = []
    //   this.servicio.cuotas = []
    //   for (var i = 1; i <= id.target.value; i++) {
    //     console.log(i)
    //     const obj = {
    //       cuota_numero: i,
    //       nombre: i
    //     }
    //     this.pagos2.push(obj)
    //     this.servicio.cuotas.push({
    //       cuota_numero: i,
    //       precio: null,
    //       fecha_inicio: null,
    //       fecha_finalizacion: null
    //     })
    //   }
    // },
    editarServicio (servicio, id) {
      console.log('qqqq')
      console.log(servicio)
      if (this.cargando) {
        return null
      }
      this.errores = {
        nombre: null,
        descripcion: null,
        moneda_id: null,
        cuotas_cantidad: null,
        cuotas: null,
        year_id: null,
        categoria_id: null,
        'cuotas.0.precio': null,
        'cuotas.1.precio': null,
        'cuotas.2.precio': null,
        'cuotas.3.precio': null,
        'cuotas.4.precio': null,
        'cuotas.5.precio': null,
        'cuotas.6.precio': null,
        'cuotas.7.precio': null,
        'cuotas.8.precio': null,
        'cuotas.9.precio': null,
        'cuotas.10.precio': null,
        'cuotas.11.precio': null,
        'cuotas.0.fecha_inicio': null,
        'cuotas.1.fecha_inicio': null,
        'cuotas.2.fecha_inicio': null,
        'cuotas.3.fecha_inicio': null,
        'cuotas.4.fecha_inicio': null,
        'cuotas.5.fecha_inicio': null,
        'cuotas.6.fecha_inicio': null,
        'cuotas.7.fecha_inicio': null,
        'cuotas.8.fecha_inicio': null,
        'cuotas.9.fecha_inicio': null,
        'cuotas.10.fecha_inicio': null,
        'cuotas.11.fecha_inicio': null,
        'cuotas.0.fecha_finalizacion': null,
        'cuotas.1.fecha_finalizacion': null,
        'cuotas.2.fecha_finalizacion': null,
        'cuotas.3.fecha_finalizacion': null,
        'cuotas.4.fecha_finalizacion': null,
        'cuotas.5.fecha_finalizacion': null,
        'cuotas.6.fecha_finalizacion': null,
        'cuotas.7.fecha_finalizacion': null,
        'cuotas.8.fecha_finalizacion': null,
        'cuotas.9.fecha_finalizacion': null,
        'cuotas.10.fecha_finalizacion': null,
        'cuotas.11.fecha_finalizacion': null
      }
      this.cargando = true
      serviciosService
        .editarServicio(servicio, id)
        .then(respuesta => {
          this.cargando = false
          if (respuesta.success) {
            console.log('SIIIIII')
            this.servicio = {
              nombre: null,
              descripcion: null,
              precio: null,
              cuotas_cantidad: null,
              cuotas: null,
              year_id: null,
              categoria_id: null
            }
            this.store.setStatus({
              msg: 'El servicio se editó exitosamente',
              type: 'success'
            })
            this.$router.push('/listar-servicios')
            this.errores = {
              nombre: null,
              descripcion: null,
              moneda_id: null,
              cuotas_cantidad: null,
              cuotas: null,
              year_id: null,
              categoria_id: null,
              'cuotas.0.precio': null,
              'cuotas.1.precio': null,
              'cuotas.2.precio': null,
              'cuotas.3.precio': null,
              'cuotas.4.precio': null,
              'cuotas.5.precio': null,
              'cuotas.6.precio': null,
              'cuotas.7.precio': null,
              'cuotas.8.precio': null,
              'cuotas.9.precio': null,
              'cuotas.10.precio': null,
              'cuotas.11.precio': null,
              'cuotas.0.fecha_inicio': null,
              'cuotas.1.fecha_inicio': null,
              'cuotas.2.fecha_inicio': null,
              'cuotas.3.fecha_inicio': null,
              'cuotas.4.fecha_inicio': null,
              'cuotas.5.fecha_inicio': null,
              'cuotas.6.fecha_inicio': null,
              'cuotas.7.fecha_inicio': null,
              'cuotas.8.fecha_inicio': null,
              'cuotas.9.fecha_inicio': null,
              'cuotas.10.fecha_inicio': null,
              'cuotas.11.fecha_inicio': null,
              'cuotas.0.fecha_finalizacion': null,
              'cuotas.1.fecha_finalizacion': null,
              'cuotas.2.fecha_finalizacion': null,
              'cuotas.3.fecha_finalizacion': null,
              'cuotas.4.fecha_finalizacion': null,
              'cuotas.5.fecha_finalizacion': null,
              'cuotas.6.fecha_finalizacion': null,
              'cuotas.7.fecha_finalizacion': null,
              'cuotas.8.fecha_finalizacion': null,
              'cuotas.9.fecha_finalizacion': null,
              'cuotas.10.fecha_finalizacion': null,
              'cuotas.11.fecha_finalizacion': null
            }
          } else {
            this.errores = {
              nombre: null,
              descripcion: null,
              moneda_id: null,
              cuotas_cantidad: null,
              cuotas: null,
              year_id: null,
              categoria_id: null,
              'cuotas.0.precio': null,
              'cuotas.1.precio': null,
              'cuotas.2.precio': null,
              'cuotas.3.precio': null,
              'cuotas.4.precio': null,
              'cuotas.5.precio': null,
              'cuotas.6.precio': null,
              'cuotas.7.precio': null,
              'cuotas.8.precio': null,
              'cuotas.9.precio': null,
              'cuotas.10.precio': null,
              'cuotas.11.precio': null,
              'cuotas.0.fecha_inicio': null,
              'cuotas.1.fecha_inicio': null,
              'cuotas.2.fecha_inicio': null,
              'cuotas.3.fecha_inicio': null,
              'cuotas.4.fecha_inicio': null,
              'cuotas.5.fecha_inicio': null,
              'cuotas.6.fecha_inicio': null,
              'cuotas.7.fecha_inicio': null,
              'cuotas.8.fecha_inicio': null,
              'cuotas.9.fecha_inicio': null,
              'cuotas.10.fecha_inicio': null,
              'cuotas.11.fecha_inicio': null,
              'cuotas.0.fecha_finalizacion': null,
              'cuotas.1.fecha_finalizacion': null,
              'cuotas.2.fecha_finalizacion': null,
              'cuotas.3.fecha_finalizacion': null,
              'cuotas.4.fecha_finalizacion': null,
              'cuotas.5.fecha_finalizacion': null,
              'cuotas.6.fecha_finalizacion': null,
              'cuotas.7.fecha_finalizacion': null,
              'cuotas.8.fecha_finalizacion': null,
              'cuotas.9.fecha_finalizacion': null,
              'cuotas.10.fecha_finalizacion': null,
              'cuotas.11.fecha_finalizacion': null,
              ...respuesta.errors
            }
          }
        })
    },
    errorPrecioCuota (id) {
      const x = id - 1
      return this.errores['cuotas.' + x + '.precio'][0]
    },
    errorFechaInicioCuota (id) {
      const x = id - 1
      return this.errores['cuotas.' + x + '.fecha_inicio'][0]
    },
    errorFechaFinalizacionCuota (id) {
      const x = id - 1
      return this.errores['cuotas.' + x + '.fecha_finalizacion'][0]
    },
    numeroCuota (id) {
      const x = id - 1
      console.log('Estoy en numeroCuota ' + x)
      return x
      // return this.errores['cuotas.' + x + '.precio'][0] !== null
    }
  },
  computed: {
    mostrarCuotas: function () {
      if (this.servicio.cuotas_cantidad != null) {
        console.log('MOSTRAR CUOTAS!!!!!')
        return true
      }
      return false
    }
  },
  mounted: function () {
    serviciosService
      .traerServicioConCuotasPorId(this.$route.params.id)
      .then(respuesta => {
        console.log(respuesta)
        // this.cargando = false
        this.servicio = respuesta[0]
        this.pagos2 = respuesta[0].cuotas
        console.log(respuesta[0].cuotas)
        console.log(respuesta[0].cuotas.length)
        if (respuesta[0].year_id == null) {
          console.log('e5555555')
          this.mostrarYear = false
        }
        this.cantinadCuotas = respuesta[0].cuotas.length + 1
      })
    pagosService
      .traerMonedas()
      .then(respuesta => {
        // this.cargando = false
        this.monedas = respuesta
        console.log('Monedas: ', respuesta)
      })
    serviciosService
      .traerCategoriasTodas()
      .then(respuesta => {
        // this.cargando = false
        this.categorias = respuesta
      })
    pagosService
      .traerYearsDePago()
      .then(respuesta => {
        // this.cargando = false
        this.years = respuesta
        console.log('Years: ', respuesta)
      })
  }
}
</script>
